import { render, staticRenderFns } from "./TheCookieConsent.vue?vue&type=template&id=fe81c2e6"
import script from "./TheCookieConsent.vue?vue&type=script&lang=js"
export * from "./TheCookieConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports